"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Actions = require("../../../store/actions/Actions");
var _CheckboxView = _interopRequireDefault(require("./CheckboxView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ReduxCheckbox = function ReduxCheckbox(props) {
  return /*#__PURE__*/_react.default.createElement(_CheckboxView.default, props);
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    filterState: state.statusReducer.filterState
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onToggle: function onToggle(view) {
      return dispatch((0, _Actions.toggleCheckBox)(view));
    }
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReduxCheckbox);
exports.default = _default;